var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDartBoard2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_dart_board_2)",
    fill: "#F26F4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.713 20.63 3.725-3.726a5.366 5.366 0 0 0-2.896-.846 5.406 5.406 0 0 0-5.4 5.4c0 2.977 2.423 5.4 5.4 5.4 2.977 0 5.4-2.423 5.4-5.4a5.365 5.365 0 0 0-.846-2.896l-3.725 3.724-1.658-1.657z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.084 21.458a18.51 18.51 0 0 0-2.358-9.055l-4.616.633a14.237 14.237 0 0 1 2.747 8.422c0 7.893-6.422 14.315-14.315 14.315S4.228 29.35 4.228 21.458 10.649 7.143 18.542 7.143c3.146 0 6.057 1.021 8.422 2.748l.633-4.617a18.51 18.51 0 0 0-9.055-2.358 18.42 18.42 0 0 0-13.111 5.43A18.42 18.42 0 0 0 0 21.458a18.42 18.42 0 0 0 5.43 13.111A18.42 18.42 0 0 0 18.543 40a18.42 18.42 0 0 0 13.112-5.43 18.42 18.42 0 0 0 5.43-13.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.542 9.487c-6.6 0-11.97 5.37-11.97 11.97 0 6.602 5.37 11.972 11.97 11.972 6.601 0 11.971-5.37 11.971-11.971 0-2.88-1.022-5.524-2.722-7.592l-3.01 3.01a7.701 7.701 0 0 1 1.505 4.582c0 4.27-3.474 7.743-7.744 7.743S10.8 25.727 10.8 21.458c0-4.27 3.474-7.743 7.743-7.743 1.713 0 3.298.559 4.582 1.504l3.01-3.01a11.915 11.915 0 0 0-7.592-2.722zM35.18 0l-5.209 5.209-.765 5.585 5.585-.766L40 4.82l-3.516-1.304L35.18 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_dart_board_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDartBoard2);
export default __webpack_public_path__ + "static/media/icon_dart_board_2.2d5d94933355244845b5389f9f5c6f87.svg";
export { ForwardRef as ReactComponent };